import React from 'react';
import PropTypes from 'prop-types';
import './Logo.scss';
import safecoLogoImg from '../../assets/images/safeco-logo.png';

const Logo = ({ secondaryLogoUrl, type, alt, datacy }) => {
    return (
        <div className={`logo ${type || ''}`}>
            <img
                className={`safeco-logo ${type || ''}`}
                src={safecoLogoImg}
                alt="Safeco logo"
                datacy="safeco-logo"
            />
            <img className="secondary-logo" src={secondaryLogoUrl} alt={alt} datacy={datacy} />
        </div>
    );
};

Logo.propTypes = {
    secondaryLogoUrl: PropTypes.string,
    alt: PropTypes.string
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.jsx